// extracted by mini-css-extract-plugin
export default {"container":"WatchList_container__o3q7-","content":"WatchList_content__UpYdX","emptyShelf":"WatchList_emptyShelf__44HVF"};